export default "__VITE_ASSET__BFXnrJ92__"